export default __webpack_public_path__ + "static/travel5-5a0192ad057b58a72e81beb305da0cd0.png";